import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import _pt from 'prop-types';
import 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsxs, jsx } from 'react/jsx-runtime';

var AccordionSection = function AccordionSection(_ref) {
  var children = _ref.children,
      collapseTitle = _ref.collapseTitle,
      _ref$disableAnimation = _ref.disableAnimations,
      disableAnimations = _ref$disableAnimation === void 0 ? false : _ref$disableAnimation,
      expandTitle = _ref.expandTitle,
      getBlocksWith = _ref.getBlocksWith,
      isOpen = _ref.isOpen,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      onClick = _ref.onClick,
      renderCollapseTitle = _ref.renderCollapseTitle,
      renderExpandTitle = _ref.renderExpandTitle,
      renderSection = _ref.renderSection,
      section = _ref.section,
      showToggleButtons = _ref.showToggleButtons,
      _ref$topLevel = _ref.topLevel,
      topLevel = _ref$topLevel === void 0 ? false : _ref$topLevel;
  var toggleButtons = showToggleButtons && children;

  var handleClick = function handleClick() {
    onClick(section);
  };

  var toggleAccordionTitle = isOpen ? collapseTitle || renderCollapseTitle(section) : expandTitle || renderExpandTitle(section);
  return /*#__PURE__*/jsxs("section", {
    id: "section-".concat(section.id),
    className: cn(getBlocksWith("__section"), disableAnimations && getBlocksWith("__section--disable-animations"), isOpen && getBlocksWith("__section--open"), topLevel && getBlocksWith("__section--top-level")),
    children: [/*#__PURE__*/jsxs("div", {
      className: cn(getBlocksWith("__header"), isSelected && getBlocksWith("__header--selected")),
      children: [/*#__PURE__*/jsx("div", {
        className: getBlocksWith("__toggle-button"),
        children: toggleButtons && /*#__PURE__*/jsx("button", {
          "aria-label": toggleAccordionTitle,
          onClick: handleClick,
          "aria-expanded": isOpen,
          children: /*#__PURE__*/jsx(FontAwesomeIcon, {
            className: cn(isOpen ? getBlocksWith("__toggle-button--open") : getBlocksWith("__toggle-button--closed")),
            size: "2x",
            icon: faAngleRight,
            title: toggleAccordionTitle
          })
        })
      }), /*#__PURE__*/jsx("section", {
        className: cn(getBlocksWith("__title")),
        children: renderSection(section)
      })]
    }), /*#__PURE__*/jsx("div", {
      hidden: !isOpen,
      className: cn(getBlocksWith("__children"), isOpen && getBlocksWith("__children--open")),
      children: children
    })]
  });
};

AccordionSection.propTypes = {
  children: _pt.node,
  collapseTitle: _pt.string.isRequired,
  disableAnimations: _pt.bool,
  expandTitle: _pt.string,
  isOpen: _pt.bool.isRequired,
  isSelected: _pt.bool,
  onClick: _pt.func.isRequired,
  renderCollapseTitle: _pt.func.isRequired,
  renderExpandTitle: _pt.func.isRequired,
  renderSection: _pt.func.isRequired,
  section: _pt.shape({
    id: _pt.string.isRequired,
    subSections: _pt.arrayOf(_pt.shape({
      id: _pt.string.isRequired,
      subSections: _pt.arrayOf(_pt.shape({
        id: _pt.string.isRequired,
        subSections: _pt.arrayOf(_pt.object).isRequired
      })).isRequired
    })).isRequired
  }).isRequired,
  showToggleButtons: _pt.bool.isRequired,
  topLevel: _pt.bool
};

// Ripped from here https://alligator.io/react/react-accordion-component/
// and here https://codesandbox.io/s/p51vxkr7j
var Accordion = function Accordion(_ref) {
  var className = _ref.className,
      _ref$collapseTitle = _ref.collapseTitle,
      collapseTitle = _ref$collapseTitle === void 0 ? "" : _ref$collapseTitle,
      _ref$disableAnimation = _ref.disableAnimations,
      disableAnimations = _ref$disableAnimation === void 0 ? false : _ref$disableAnimation,
      _ref$expandAllSection = _ref.expandAllSections,
      expandAllSections = _ref$expandAllSection === void 0 ? false : _ref$expandAllSection,
      _ref$expandTitle = _ref.expandTitle,
      expandTitle = _ref$expandTitle === void 0 ? "" : _ref$expandTitle,
      items = _ref.items,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$openSections = _ref.openSections,
      openSections = _ref$openSections === void 0 ? {} : _ref$openSections,
      _ref$renderCollapseTi = _ref.renderCollapseTitle,
      renderCollapseTitle = _ref$renderCollapseTi === void 0 ? function () {
    return "";
  } : _ref$renderCollapseTi,
      _ref$renderExpandTitl = _ref.renderExpandTitle,
      renderExpandTitle = _ref$renderExpandTitl === void 0 ? function () {
    return "";
  } : _ref$renderExpandTitl,
      renderSection = _ref.renderSection,
      _ref$selectedId = _ref.selectedId,
      selectedId = _ref$selectedId === void 0 ? "" : _ref$selectedId,
      _ref$topLevel = _ref.topLevel,
      topLevel = _ref$topLevel === void 0 ? false : _ref$topLevel;
  var getBlocksWith = createBemBlockBuilder([className, "eb-accordion"]);

  var renderSubSections = function renderSubSections(subSections) {
    return subSections && subSections.length > 0 && /*#__PURE__*/jsx(Accordion, {
      className: className,
      renderCollapseTitle: renderCollapseTitle,
      collapseTitle: collapseTitle,
      disableAnimations: disableAnimations,
      expandAllSections: expandAllSections,
      renderExpandTitle: renderExpandTitle,
      expandTitle: expandTitle,
      items: subSections,
      onClick: onClick,
      openSections: openSections,
      renderSection: renderSection,
      selectedId: selectedId
    });
  };

  return /*#__PURE__*/jsx("div", {
    className: cn(getBlocksWith(), topLevel && getBlocksWith("--top-level")),
    children: items && items.length && items.map(function (section) {
      var id = section.id,
          subSections = section.subSections;
      return /*#__PURE__*/jsx(AccordionSection, {
        getBlocksWith: getBlocksWith,
        renderCollapseTitle: renderCollapseTitle,
        collapseTitle: collapseTitle,
        disableAnimations: disableAnimations,
        renderExpandTitle: renderExpandTitle,
        expandTitle: expandTitle,
        isOpen: expandAllSections || !!openSections[id],
        isSelected: id === selectedId,
        onClick: onClick,
        renderSection: renderSection,
        section: section,
        showToggleButtons: !expandAllSections,
        topLevel: topLevel,
        children: renderSubSections(subSections)
      }, id);
    })
  });
};

export { Accordion, Accordion as default };
//# sourceMappingURL=accordion-esm.js.map
